// extracted by css-extract-rspack-plugin
export default {"overlay":"gQLd6CBjbxsBaxqJ"};